export default __webpack_public_path__ + "static/media/dkflag.13c1c1be.svg";